import { TeamInLeague } from '../domain/entities';
import { TEAM_BADGE_ICONS } from '../domain/constants';

/**
 * Assign unique random badges to all teams
 * Ensures no two teams have the same badge (within all teams)
 */
export const assignTeamBadges = (allTeams: TeamInLeague[]): void => {
    // Shuffle badge icons
    const shuffledBadges = [...TEAM_BADGE_ICONS].sort(() => Math.random() - 0.5);

    // Assign badges to teams, cycling through badges if we have more teams than badges
    allTeams.forEach((team, index) => {
        const badgeIndex = index % shuffledBadges.length;
        team.badge = shuffledBadges[badgeIndex];
    });
};

/**
 * Get a new random badge for a team, avoiding any badges already used by other teams
 */
export const getUnusedBadge = (usedBadges: Set<string>): string => {
    const availableBadges = TEAM_BADGE_ICONS.filter(badge => !usedBadges.has(badge));

    if (availableBadges.length === 0) {
        // If all badges are used, just pick a random one
        return TEAM_BADGE_ICONS[Math.floor(Math.random() * TEAM_BADGE_ICONS.length)];
    }

    return availableBadges[Math.floor(Math.random() * availableBadges.length)];
};

/**
 * Convert badge icon name to Font Awesome icon import
 * E.g., 'crown' -> faCrown
 */
export const iconNameToFontAwesome = (badgeName: string): string => {
    // Convert kebab-case to camelCase and prepend 'fa'
    const camelCase = badgeName
        .split('-')
        .map((word, index) => {
            if (index === 0) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('');

    return `fa${camelCase.charAt(0).toUpperCase()}${camelCase.slice(1)}`;
};
